import { Box, Button, Typography, useTheme } from "@mui/material";
import React from "react";
import documentcoverimage from "../../../../../../../media/images/documentcoverimage.png";
import ArrowDownSVG from "../../../../../../../media/images/icons/arrow-down";
import UploadDocIcon from "../../../../../../../media/images/icons/upload-doc";
import UploadDocIdentityIcon from "../../../../../../../media/images/icons/upload_identity_doc";
import PasswordEyes from "../../../../../../../media/images/icons/password_eyes";

export default function DocumentCard() {
  const theme = useTheme();

  return (
    <Box
      sx={{
        // border: "1px solid gray",
        display: "flex",
        position: "relative",
        flexDirection: "column",
        gap: "8px",
      }}
    >
      <Typography
        sx={{
          textAlign: "center",
          fontWeight: "600",
          color: "primary.main",
        }}
      >
        کارت ملی(صفحه رو)
      </Typography>
      <img
        style={{
          width: "100%",
          height: "200px",
          objectFit: "cover",
          borderRadius: "16px",
        }}
        src={documentcoverimage}
        alt=""
      />
      <Box
        sx={{
          width: "100%",
          paddingX: "8px",
          position: "absolute",
          display: "flex",
          bottom: "8px",
          alignItems: "center",
          // border: "1px solid gray",
          gap: "8px",
        }}
      >
        <Button
          //   onClick={() => toggleBox()}
          sx={{
            display: "flex",
            borderRadius: "6px",
            alignItems: "center",
            //   border: "1px solid gray",
            minWidth: "0px !important",
            height: "fit-content",
            padding: "10px 8px",
            gap: "4px",
            //   borderColor: `${theme.palette.secondary.main} !important`,
            backgroundColor: `${theme.palette.primary.main} !important`,
            "& .MuiTouchRipple-root": {
              color: `#fff !important`,
              borderWidth: "0px !important",
            },
            "& .MuiButtonBase-root": {
              color: `${theme.palette.error.main} !important`,
              borderWidth: "0px !important",
              minWidth: "0px !important",
            },
            "& .MuiButton-root": {
              minWidth: "0px !important",
            },
          }}
        >
          <Typography
            sx={{
              color: "#fff",
              fontSize: "12px",
              whiteSpace: "nowrap",
            }}
          >
            مشاهده/ویرایش{" "}
          </Typography>

          <PasswordEyes size={20} color={"#fff"} />
        </Button>
        <Button
          //   onClick={() => toggleBox()}
          sx={{
            flex: "1",
            borderRadius: "6px",

            display: "flex",
            alignItems: "center",
            //   border: "1px solid gray",
            minWidth: "0px !important",
            height: "fit-content",
            padding: "10px 8px",
            gap: "4px",
            //   borderColor: `${theme.palette.secondary.main} !important`,
            backgroundColor: `${theme.palette.secondary.main} !important`,
            "& .MuiTouchRipple-root": {
              color: `#fff !important`,
              borderWidth: "0px !important",
            },
            "& .MuiButtonBase-root": {
              color: `${theme.palette.error.main} !important`,
              borderWidth: "0px !important",
              minWidth: "0px !important",
            },
            "& .MuiButton-root": {
              minWidth: "0px !important",
            },
          }}
        >
          <UploadDocIdentityIcon size={20} color={"#fff"} />

          <Typography
            sx={{
              color: "#fff",
              fontSize: "12px",
              whiteSpace: "nowrap",
            }}
          >
            تغییر صفحه پشت کارت ملی{" "}
          </Typography>
        </Button>
      </Box>
    </Box>
  );
}
